export const DownloadDocumentType = {
  XLSX: 'XLSX',
  CSV: 'CSV',
};

export type DownloadDocumentType =
  (typeof DownloadDocumentType)[keyof typeof DownloadDocumentType];
